import axios, { AxiosResponse } from 'axios'

const validateAuth = (token: string | null): Promise<AxiosResponse> => {
  const apiPath = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_AUTH_ENDPOINT}`

  return axios
    .post(
      `${apiPath}`,
      {},
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      },
    )
    .then((response: AxiosResponse) => response)
    .catch((error) => error)
}

export default validateAuth
